import $ from 'jquery';

$(document).on('ready', () => {
  let isApprovedToSignUp = false;
  const enableContinueBtn = () => {
    const radioAmounts = $('.apply__fields').find('.form__field').length;
    const checkedRadios = $('.apply__fields').find(
      'input[type="radio"]:checked'
    );

    if (checkedRadios.length !== radioAmounts) {
      $('#pip-apply-continue').prop('disabled', true);
    } else {
      $('#pip-apply-continue').prop('disabled', false);
    }

    checkedRadios.each((i, element) => {
      if ($(element).val() === '0') {
        isApprovedToSignUp = false;
        return false;
      } else {
        isApprovedToSignUp = true;
        return true;
      }
    });
  };

  // turn into resuable continue trigger that loads up form 
  const showPCRPApplySection = () => {
    $('.hero--pip')
      .addClass('hero--pip--apply')
      .removeClass('hero--pip--landing');

    const $landingSection = $('[data-section="landing"]');
    const $applySection = $('[data-section="apply"]');

    $applySection.css({
      opacity: 0,
      paddingTop: '10px'
    });

    $landingSection.animate(
      {
        opacity: 0,
        paddingTop: '10px'
      },
      300,
      'swing',
      () => {
        $landingSection.hide();

        $applySection.delay(100).removeClass('u--display-none').show().animate(
          {
            opacity: 1,
            paddingTop: '-10px'
          },
          300,
          'swing'
        );
      }
    );
  };

  /* Click handler for /pcrp progression */
  $('#pip-apply').on('click', showPCRPApplySection);

  /* Check for ?status=apply_pcrp in URL if coning from indexed landing page */
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('status') === 'pcrp_apply') {
    showPCRPApplySection();
  };


  $('input[type="radio"]').on('change', () => enableContinueBtn());

  // Simply form validation on 'Continue' click.
  $('#pip-apply-continue').on('click', (event) => {
    $('.apply-notice').hide().removeClass('u--display-none');

    if (isApprovedToSignUp) {
      if (window.wlPipConfig.loggedIn === '1') {
        window.location.href = '/pcrp/dashboard/';
      } else {
        // google tracking for clicking "continue"
        // gtag_report_conversion();
        window.location.href = `/account/signup/?redirect_to=${$(
          event.currentTarget
        ).data('redirect')}`;
      }
    } else {
      $('.apply-notice').show();
    }
  });
});
